import { render, staticRenderFns } from "./demo1.vue?vue&type=template&id=770f8d14&scoped=true&"
import script from "./demo1.vue?vue&type=script&lang=js&"
export * from "./demo1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770f8d14",
  null
  
)

export default component.exports